import {TICKET_SUCCESS,TICKET_UPDATE,TICKET_CLEAR} from "../constants";



export function ticket(state = [], action) {
    switch (action.type) {
        case TICKET_SUCCESS:
            return action.payload;
        case TICKET_UPDATE:
            return action.payload;
        case TICKET_CLEAR:
            return state = [];
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/ticketItem.js